export const formatMoney = (moola) => Number(moola).toLocaleString('en-CA', {
  style: 'currency',
  currency: 'CAD',
})

export const formatDT = (parts) => (value) => new Date(value).toLocaleString(
  {},
  parts.reduce((acc, curr) => {
    acc[curr] = '2-digit'
    return acc
  }, {}),
)

export const formatDateTime = formatDT(['year', 'month', 'day', 'hour', 'minute'])

export const formatDate = formatDT(['year', 'month', 'day'])
